export default __webpack_public_path__ + "static/media/04 exile.bb88e8b6.mp3";